module.exports = __webpack_public_path__ + "img/oem4.8a241620.png";